//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ShowText from "@/0/components/comForm/comEditControls/comShowText.vue";
import EditHidden from "@/0/components/comForm/comEditControls/comEditHidden.vue";

import EditInput from "@/0/components/comForm/comEditControls/comEditInput.vue";
import EditTextArea from "@/0/components/comForm/comEditControls/comEditTextArea.vue";

import EditDate from "@/0/components/comForm/comEditControls/comEditDate.vue";
import EditDateTime from "@/0/components/comForm/comEditControls/comEditDateTime.vue";

import EditSwitch from "@/0/components/comForm/comEditControls/comEditSwitch.vue";
import EditCheckBox from "@/0/components/comForm/comEditControls/comEditCheckBox.vue";

import EditDropDownList from "@/0/components/comForm/comEditControls/comEditDropDownList.vue";
import EditRadioGroup from "@/0/components/comForm/comEditControls/comEditRadioGroup.vue";

import EditArea from "@/0/components/comForm/comEditControls/comEditArea.vue";

export default {
  props: ["queryCondition"],
  components: {
    "show-text": ShowText,
    "edit-hidden": EditHidden,

    "edit-input": EditInput,
    "edit-textarea": EditTextArea,

    "edit-date": EditDate,
    "edit-datetime": EditDateTime,

    "edit-switch": EditSwitch,
    "edit-checkbox": EditCheckBox,

    "edit-dropdownlist": EditDropDownList,
    "edit-radio-group": EditRadioGroup,

    "edit-area": EditArea
  },
  data() {
    return {
      thisQueryCondition : this.queryCondition,            
    };
  },
  created() {
    this.initForm();
  },
  methods: {

    $reset(){
      this.thisQueryCondition = JSON.parse(JSON.stringify(this.queryCondition));
    },

    initForm() {
      if (!this.thisQueryCondition || !this.thisQueryCondition.ControlsList) {
        return;
      }

      this.thisQueryCondition.ControlsList.map(groupItem => {
        groupItem.map((controlItem, subIndex) => {});
      });
    },

    getSubmitData() {
      return this.$getSubmitData();
    },

    $getSubmitData() {
      console.log("comFormQueryEdit====$getSubmitData====");
      if (!this.thisQueryCondition || !this.thisQueryCondition.ControlsList) {
        return null;
      }

      // 将表单数据处理后返回
      let submitData = {};
      this.thisQueryCondition.ControlsList.forEach(groupItem => {
        groupItem.forEach(controlItem => {
          console.log("controlItem.ControlId", controlItem.ControlId);

          if (!controlItem.ControlId) return null;
          if (typeof(controlItem.ControlId) != "string") return null;

          if (
            controlItem.ControlValueList &&
            controlItem.ControlValueList.length > 0
          ) {
            controlItem.ControlValueList.forEach(m => {
              if(m.ControlValue){
                submitData[m.ControlId] = m.ControlValue;
              }
            });
            console.log(
              "controlItem.ControlValueList",
              controlItem.ControlValueList
            );
          }

          console.log(
            "query:" + controlItem.ControlId,
            controlItem.ControlValue
          );

          if(controlItem.ControlValue){
            submitData[controlItem.ControlId] = controlItem.ControlValue;
          }

        });
      });

      return submitData;
    }
  }
};
